import React from "react";
import ReactDOMClient from "react-dom/client";

import {
  createInstance,
  type ModuleFederation
} from "@module-federation/runtime";
import * as JSXRuntime from "react/jsx-runtime";
import ReactDOM from "react-dom";

import pkg from "../../package.json";

type PackageJson = {
  dependencies?: Record<string, string>;
};

const dependencies = (pkg as unknown as PackageJson).dependencies ?? {};
const reactVersion = dependencies.react;
const reactDomVersion = dependencies["react-dom"];

let mf: ModuleFederation | null = null;
export function getModuleFederation() {
  if (mf) return mf;

  mf = createInstance({
    name: "hf-mfRuntime-instance",
    remotes: [],
    shared: {
      react: {
        // If version can't be determined, omit it and rely on singleton + requiredVersion:false.
        ...(reactVersion ? { version: reactVersion } : {}),
        scope: "default",
        lib: () => React,
        shareConfig: { singleton: true, requiredVersion: false }
      },
      "react-dom": {
        ...(reactDomVersion ? { version: reactDomVersion } : {}),
        scope: "default",
        lib: () => ReactDOM,
        shareConfig: { singleton: true, requiredVersion: false }
      },
      "react-dom/client": {
        ...(reactDomVersion ? { version: reactDomVersion } : {}),
        scope: "default",
        lib: () => ReactDOMClient,
        shareConfig: { singleton: true, requiredVersion: false }
      },
      "react/jsx-runtime": {
        ...(reactVersion ? { version: reactVersion } : {}),
        scope: "default",
        lib: () => JSXRuntime,
        shareConfig: { singleton: true, requiredVersion: false }
      }
    }
  });

  return mf;
}
